import { api, type OrgRole } from "@/lib/api";
import { useSession } from "@/lib/auth-client";
import { useQuery } from "@tanstack/react-query";

// The signed-in user's effective role in the active org, with the org itself
// (name, members, invitations). Shared by org-settings surfaces that gate
// mutations on owner/admin. Read from boo-backend, which answers for a super
// admin in any org; every org mutation invalidates ["org-full", orgId].
export function useOrgRole() {
  const { data: session } = useSession();
  const orgId = session?.session.activeOrganizationId;

  const query = useQuery({
    queryKey: ["org-full", orgId],
    enabled: !!orgId,
    queryFn: () => api.org.details(),
  });

  const org = query.data?.data;
  const myRole: OrgRole | undefined = org?.myRole;

  return {
    orgId,
    org,
    myRole,
    canManage: myRole === "owner" || myRole === "admin",
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
